import { Component, Input, OnChanges } from '@angular/core';
import { AuditData } from '../../.././../../security-admin/models/field-audit';
import { HistoryService } from '../../../../../admin/services/history.service';

@Component({
  selector: 'wre-field-history',
  templateUrl: './field-history.component.html',
  styleUrls: ['./field-history.component.sass']
})
export class FieldHistoryComponent implements OnChanges{
  private fieldType:string;
  private _fieldId: string;
  get fieldId(): string {
    return this._fieldId;
  }
  @Input() set fieldId(value: string) {
    this._fieldId = value;
    this._historyService.assignDateValues();  
  }
  @Input() AuditData:AuditData[];

  ngOnChanges(){
    this.getFieldAuditData();
    if(this.AuditData.length>0)
      this.fieldType = this.AuditData[0].title?.includes("Reviewer") ? "Reviewer" : "";
  }

  fieldAudit: AuditData[];
  historyData = this._historyService.historyData;
  errorMessage: boolean;
  errorMessageInfo: string;
  error: any;
  loading:boolean = false;
  sortToggle = false;

  constructor(private _historyService:HistoryService) {}

  getFieldAuditData() { 
      this.loading =true;
      this.fieldAudit = this.AuditData;
      this.setHistoryInfo();
      if(this.fieldAudit)
       this.loading = false;
  } 
  
  setHistoryInfo(): void {
    this.sort(this.fieldAudit);
    this._historyService.groupTimeStamp(this.fieldAudit);
  }

  private sort(updateInfo: AuditData[]) {
    updateInfo.sort((a, b) => {
      return a.date > b.date ? -1 : 1; 
    });
  }

  reverseHistoryData() {
    this._historyService.reverseHistoryData();
    this.sortToggle = !this.sortToggle ;
  }
}

